import { useState } from "react";
import { useTranslation } from "react-i18next";

const FAQ_ITEMS = [
  { q: "faq.1q", a: "faq.1a" },
  { q: "faq.2q", a: "faq.2a" },
  { q: "faq.3q", a: "faq.3a" },
  { q: "faq.4q", a: "faq.4a" },
  { q: "faq.5q", a: "faq.5a" },
];

export default function Faq() {
  const { t } = useTranslation();
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="w-full max-w-3xl mx-auto">
        <div className="text-center">
          <h2 className="text-2xl md:text-4xl font-heading font-bold">{t("faq.title")}</h2>
        </div>

        <div className="mt-10 space-y-3">
          {FAQ_ITEMS.map((item, i) => (
            <div
              key={item.q}
              className="rounded-lg bg-background-50 border border-background-200 overflow-hidden"
            >
              <button
                onClick={() => setOpen(open === i ? -1 : i)}
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
              >
                <span className="font-medium text-foreground-900">{t(item.q)}</span>
                <span
                  className={`w-6 h-6 flex items-center justify-center shrink-0 text-foreground-500 transition-transform ${
                    open === i ? "rotate-180" : ""
                  }`}
                >
                  <i className="ri-arrow-down-s-line"></i>
                </span>
              </button>
              {open === i && (
                <div className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">
                  {t(item.a)}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}